import React from "react";
import "./Page.css";

const LogoBar: React.FunctionComponent<{}> = () => (
	<div className="Page-logobar w3-bar w3-top">
		<img src="/biglogo.svg" className="Page-top-logo" alt="#tagman" />
	</div>
);

export default LogoBar;
